module.exports = __webpack_public_path__ + "img/Home1m1.20bf3631.png";